import { forwardRef, useEffect, useRef } from 'react';
import clsx from 'clsx';
import {
  Analysis,
  CallBack,
  Completion,
  Damage
} from '@gjensidige/builders-icons/symbols';
import type { TrackingProp } from '../types';
import { useTracking } from '../utils';
import styles from './status.module.less';

export type StatusProps = React.ComponentPropsWithoutRef<'section'> & {
  tracking?: TrackingProp;
  variant?: keyof typeof ICONS | 404 | 500;
};

const ICONS = {
  '404': Analysis,
  '500': Damage,
  callback: CallBack,
  completion: Completion
};

export const Status = forwardRef<HTMLDivElement, StatusProps>(function Status(
  { className, children, tracking = false, variant = 404, ...rest },
  ref
) {
  const isTracked = useRef(false); // Using useRef as it does not trigger re-render
  const hasEventLabel = typeof tracking === 'object' && !!tracking.eventLabel;
  const track = useTracking(hasEventLabel && tracking);
  const Icon = ICONS[`${variant}`];

  // Only track first impression
  useEffect(() => {
    if (!isTracked.current && (isTracked.current = true))
      track({
        eventCategory: `status_${variant}`,
        eventAction: 'impression'
      });
  }, [isTracked, track, variant]);

  return (
    <section className={clsx(styles.status, className)} ref={ref} {...rest}>
      <Icon preserveAspectRatio="xMaxYMin meet" />
      {children}
    </section>
  );
});
